<template>
  <div class="loan-record-detail-container">
    <van-nav-bar
      :title="locale == 'zh' ? '詳情' : 'Detail'"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="content-top">{{loanOrderList[0].order.amount}} USDT <span>{{ locale == 'zh' ? '貸款成功' : 'Successful' }}</span></div>
      <div class="content-bot">
        <van-tabs v-model="active" color="#0062f8">
          <van-tab
            :title="locale == 'zh' ? '分期信息' : 'Installment information'"
          >
            <div class="info-box">
              <div class="info-box-row">
                <div class="info-box-row-left">
                  {{ locale == "zh" ? "申请时间" : "Application time" }}
                </div>
                <div class="info-box-row-right">
                  {{
                    (loanOrderList[0].created_at * 1000)
                      | dateFormat("dd-MM-yyyy")
                  }}
                </div>
              </div>
              <div class="info-box-row">
                <div class="info-box-row-left">
                  {{ locale == "zh" ? "期数" : "Period" }}
                </div>
                <div class="info-box-row-right">
                  {{ loanOrderList.length }}
                </div>
              </div>
              <div class="info-box-row">
                <div class="info-box-row-left">
                  {{ locale == "zh" ? "每期应还" : "Repayable each period" }}
                </div>
                <div class="info-box-row-right">
                  USDT {{ loanOrderList[0].sum }} 
                </div>
              </div>
              <div class="info-box-row">
                <div class="info-box-row-left">
                  {{ locale == "zh" ? "每期本金" : "Principal" }}
                </div>
                <div class="info-box-row-right">
                  USDT {{ Number(loanOrderList[0].principal).toFixed(4) }}
                </div>
              </div>
              <div class="info-box-row">
                <div class="info-box-row-left">
                  {{ locale == "zh" ? "分期利息" : "Interest installment" }}
                </div>
                <div class="info-box-row-right">
                  USDT {{ Number(loanOrderList[0].interest).toFixed(4) }} 
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab :title="locale == 'zh' ? '還款計劃' : 'Repayment plan'">
            <div class="repayment-box">
              <div
                class="repayment-box-row"
                v-for="item in loanOrderList"
                :key="item.id"
              >
                <div class="row-left">
                  <span class="period">{{ item.period_index }}</span>
                  <div class="money-box">
                    <div class="money-box-top">
                      {{ item.sum }}
                      <div class="repay-btn" @click="repayment(item.id)">
                        <span v-if="item.status == 1 || item.status == 3">{{
                          locale == "zh" ? "還款" : "Repay"
                        }}</span>
                      </div>
                    </div>
                    <div class="money-box-bot">
                      {{
                        locale == "zh"
                          ? "含分期利息 "
                          : "Including installment interest "
                      }}{{ item.interest }} USDT
                    </div>
                  </div>
                </div>
                <div class="row-right">
                  <span v-if="item.status == 1">{{
                    locale == "zh" ? "待還款" : "Pending"
                  }}</span>
                  <span v-if="item.status == 2" style="color: green">{{
                    locale == "zh" ? "已還款" : "Repaid"
                  }}</span>
                  <span v-if="item.status == 3" style="color: red">{{
                    locale == "zh" ? "已逾期" : "Overdue"
                  }}</span>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: "en",
      active: 0,
      loanOrderList: [],
    };
  },
  created() {
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.getLoanDetail(this.$route.query.id);
  },
  methods: {
    navBack() {
      this.$router.go(-1);
    },
    async getLoanDetail(id) {
      const res = await this.$api.getLoanDetail({ id });
      if (res.code == 200) {
        this.loanOrderList = res.data;
      }
    },
    async repayment(item_id) {
      this.$Toast.loading({ forbidClick: true, duration: 0 });
      const res = await this.$api.repayment({ item_id });
      if (res.code == 200) {
        this.$Toast.success("successful repayment");
        this.getLoanDetail(this.$route.query.id)
      } else {
        this.$Toast.clear()
        this.$Dialog.alert({
          message: res.message,
          confirmButtonText: "confirm",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loan-record-detail-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    &-top {
      padding: 30px 0;
      background: #0062f8;
      color: #fff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      span {
        padding: 2px 5px;
        font-size: 6px;
        color: #0062f8;
        background: #fff;
        border-radius: 5px;
        margin-left: 5px;
      }
    }
    &-bot {
      .info-box {
        padding: 0 10px;
        background: #fff;
        margin-top: 10px;
        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 15px 0;
          border-bottom: 1px solid #ddd;
          font-size: 14px;
          &-left {
          }
          &-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            .right-bot {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              flex-wrap: wrap;
              color: #999;
              font-size: 10px;
              margin-top: 5px;
              span {
                &:last-child {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
      .repayment-box {
        padding: 0 15px;
        background: #fff;
        &-row {
          padding: 15px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #ddd;
          .row-left {
            display: flex;
            align-items: center;
            .period {
              font-weight: 600;
            }
            .money-box {
              margin-left: 5px;
              &-top {
                display: flex;
                align-items: center;
                .repay-btn {
                  color: #0062f8;
                  margin-left: 3px;
                  font-weight: 600;
                }
              }
              &-bot {
                font-size: 12px;
                color: #999;
                margin-top: 2px;
              }
            }
          }
        }
      }
    }
  }
}
</style>